import React from "react";

const Java_OOP = () => {
  return (
    <div>
      <h1>Java OOP</h1>
      <p>This page provides explanations, examples, and common use-cases for Java OOP in Java.</p>
    </div>
  );
};

export default Java_OOP;
